import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Download, FileSpreadsheet, FileText } from "lucide-react";
import { downloadFile } from "@/lib/download";
import { toast } from "sonner";

export default function ExportMenu({ base, label = "Esporta", testid = "export-menu" }) {
  const go = async (fmt) => {
    try {
      await downloadFile(`/export/${base}.${fmt}`, `${base}.${fmt}`);
      toast.success(`Report ${fmt.toUpperCase()} scaricato`);
    } catch {
      toast.error("Errore durante l'esportazione");
    }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" data-testid={testid}>
          <Download className="mr-2 h-4 w-4" />
          {label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => go("xlsx")} data-testid={`${testid}-xlsx`}>
          <FileSpreadsheet className="mr-2 h-4 w-4" />Excel (.xlsx)
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => go("pdf")} data-testid={`${testid}-pdf`}>
          <FileText className="mr-2 h-4 w-4" />PDF
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
